<template>
  <div class="md-offset mt-120">
    <md-card class="date-card">
      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>today</md-icon>
        </div>
        <h4 class="title">Podaj datę urodzenia</h4>
      </md-card-header>
      <md-card-content class="date-content">
        <div class="date-form">
          <md-field class="select">
            <label>Rok</label>
            <md-select v-model="selectedDate.year">
              <md-option v-for="year in yearArray" :key="year" :value="year">
                {{ year }}
              </md-option>
            </md-select>
          </md-field>
          <md-field class="select">
            <label>Miesiąc</label>
            <md-select v-model="selectedDate.monthIndex">
              <md-option
                v-for="(month, index) in months"
                :key="index"
                :value="index"
              >
                {{ month }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <slide-y-down-transition>
          <p class="error-message" v-if="!validateForm">
            W tym serwisie analiza oferty ubezpieczeniowej dostępna jest dla
            osób z ukończonym 18 r. życia i nieukończonym 70 r. życia
          </p>
        </slide-y-down-transition>
      </md-card-content>
      <md-button
        :disabled="!validateForm"
        @click="nextStep()"
        class="date-btn md-info"
      >
        Przejdź do konfiguratora
        <md-icon>chevron_right</md-icon>
      </md-button>
    </md-card>
  </div>
</template>

<script>
export default {
  name: 'DateAgreement',
  components: {},
  data() {
    return {
      months: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      selectedDate: {
        monthIndex: new Date().getMonth(),
        year: new Date().getFullYear() - 40,
      },
      agreed1: false,
      agreed2: false,
    }
  },
  mounted() {
    if (
      JSON.parse(localStorage.getItem('birthday')).selectedDate !== undefined
    ) {
      this.selectedDate = JSON.parse(
        localStorage.getItem('birthday')
      ).selectedDate
    }
    if (localStorage.getItem('calculation')) {
      localStorage.removeItem('calculation')
    }
  },
  computed: {
    yearArray() {
      let yearRange = []
      for (
        let i = new Date().getFullYear() - 18;
        i >= new Date().getFullYear() - 70;
        i--
      ) {
        yearRange.push(i)
      }
      return yearRange
    },
    validateForm() {
      return (
        new Date(this.selectedDate.year, this.selectedDate.monthIndex, 1) >
          new Date(new Date().getFullYear() - 70, new Date().getMonth(), 1) &&
        new Date(this.selectedDate.year, this.selectedDate.monthIndex, 1) <
          new Date(new Date().getFullYear() - 18, new Date().getMonth(), 1)
      )
    },
    age() {
      return Math.floor(
        (new Date().getTime() -
          new Date(this.selectedDate.year, this.selectedDate.monthIndex, 1)) /
          (24 * 3600 * 365.25 * 1000)
      )
    },
  },
  methods: {
    nextStep() {
      localStorage.setItem(
        'birthday',
        JSON.stringify({
          age: this.age,
          selectedDate: this.selectedDate,
        })
      )
      this.$router.push('/calc' + this.$store.state.query)
    },
  },
}
</script>

<style scoped lang="scss">
h4.title {
  font-size: 21px !important;
  font-weight: 700 !important;
}
.mt-120 {
  margin-top: 120px !important;
}
.date-wrapp {
  width: 1110px;
  margin: 0 auto;
}
.date-card {
  @media screen and (max-width: 992px) {
    margin-top: 21px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 38px;
  }
  @media screen and (max-width: 576px) {
    margin-top: 12px;
  }
}
.date-content {
  margin-top: 50px;
  padding: 0 87px 28px 127px;
  @media screen and (max-width: 992px) {
    padding: 0 40px 28px 40px;
  }
}
.date-agreement {
  margin-top: 50px;
  &:last-child {
    margin-top: 0;
  }
}
.date-form {
  display: flex;
  justify-content: space-between;
  .md-field {
    width: 49%;
  }
  label {
    margin-top: 5px;
    width: 15ex;
    display: block;
    color: #707070 !important;
    font-weight: 500 !important;
  }
  &__input {
    width: 100%;
    max-width: 559px;
    @media screen and (max-width: 768px) {
      max-width: 300px;
    }
  }
}
.error-message {
  margin: 0;
  color: #e53935;
  font-size: 12px;
}
.date-btn {
  width: fit-content;
  margin: 0 46px 30px auto;
  @media screen and (max-width: 768px) {
    margin: 0 auto 30px;
  }
}
</style>
